module.exports = __webpack_public_path__ + "static/media/UPPSCH.c12fb8e3.png";